import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { EnumHelper } from '@/helpers/enumHelper';
import { AppConfigService } from '@/services/app-config.service';
import { FileToUpload, FileUploadService, FileUploadType } from '@/services/file-upload.service';
import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import {
  Document,
  DocumentCategory,
  DocumentIdentifier,
  DocumentSummary,
  DocumentType,
  RealProperty,
  VaultService
} from '@eemo/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DocSelectDialogComponent } from '../doc-select-dialog/doc-select-dialog.component';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { PropertyDocCardComponent } from '../property-doc-card/property-doc-card.component';

@Component({
  selector: 'app-doc-add-widget',
  templateUrl: './doc-add-widget.component.html',
  styleUrls: ['./doc-add-widget.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    PropertyDocCardComponent,
    FileUploadComponent,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    TooltipDirective,
    TranslateModule
  ],
  providers: [FileUploadService]
})
export class DocAddWidgetComponent implements OnInit, OnDestroy {
  @Input() prop: RealProperty;
  @Input() withType = true;
  @Input() withTitle = true;
  // existing document
  @Input() document: Document;
  @Input() withSelect = false;

  // new upload
  @Input() category: DocumentCategory;
  @Input() type: DocumentType;
  @Input() identifier: DocumentIdentifier;
  @Input() linkObjectId?: string;
  @Input() title: string;
  @Output() docSelected: EventEmitter<DocumentSummary | Document> = new EventEmitter<DocumentSummary | Document>();
  @Output() docDeleted: EventEmitter<DocumentSummary> = new EventEmitter<DocumentSummary>();

  isLoadingUpload = false;
  createdSub = new Subscription();
  progressSub = new Subscription();
  docSub = new Subscription();
  progress = 0;

  isMobileApp = false;
  uploadDocSelected = false;

  availableDocTypes: DocumentType[] = EnumHelper.getApiEnumList(DocumentType);
  typeSelected: DocumentType;

  // uploadFile
  backendResponseUploadedFile: any = null;

  constructor(
    private vaultService: VaultService,
    private uploadService: FileUploadService,
    private dialog: MatDialog,
    private appConfigService: AppConfigService
  ) {
    // invoice selected bu default (most common document)
    this.typeSelected = DocumentType.INVOICE;
  }

  ngOnInit(): void {
    this.isMobileApp = this.appConfigService.isMobileApp;
    this.createdSub = this.uploadService.createdUid.asObservable().subscribe((uid) => {
      // upload success
      this.docSub = this.vaultService.getDocument(uid).subscribe((d) => {
        this.docSelected.emit(d);
        return this.document = d
      });
    });
  }

  ngOnDestroy(): void {
    this.createdSub.unsubscribe();
    this.progressSub.unsubscribe();
    this.docSub.unsubscribe();
  }

  onUserWantsUploadEvent(file: File): void {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const blob = new Blob([new Uint8Array(e.target.result)], { type: file.type });
        this.uploadFile(blob, file.name);
      };
      reader.readAsArrayBuffer(file);
    }
  }

  onUploadSelectedFile(event: boolean) {
    this.uploadDocSelected = event;
  }

  onDocUpdated() {}

  onDocDeleted(event: DocumentSummary) {
    this.docDeleted.emit(event);
    this.document = null;
  }

  openSelectDocument() {
    const dialogRef = this.dialog.open(DocSelectDialogComponent, {
      // width: '25rem',
      data: { property: this.prop, category: this.category }
    });
    dialogRef.afterClosed().subscribe((result: Document[]) => {
      if (result && result.length > 0) {
        this.document = result[0];
        this.docSelected.emit(this.document);
      }
    });
  }

  private getDocumentCurrentType(): DocumentType {
    return this.type ? this.type : this.typeSelected;
  }

  // ---------------------------------------- //
  //                   APIS                   //
  // ---------------------------------------- //
  uploadFile(blob: Blob, name: string): void {
    this.isLoadingUpload = true;

    const file = new File([blob], /*blob.name TODO @@@*/ '???');
    const filesToUpload: Set<FileToUpload> = new Set();
    filesToUpload.add({ file, name });
    const options = { category: this.category, type: this.getDocumentCurrentType(), linkObjectId: this.linkObjectId };
    const progressTab = this.uploadService.upload(FileUploadType.DOC, [this.prop], options, filesToUpload);
    this.progressSub = progressTab[Object.keys(progressTab).at(0)].progress.subscribe({
      next: (data) => {
        this.progress = data;
      },
      error: (err) => {
        this.isLoadingUpload = false;
        this.backendResponseUploadedFile = err;
      },
      complete: () => {
        this.isLoadingUpload = false;
        this.backendResponseUploadedFile = { status: '200' };
      }
    });
  }
}
